<template>
  <market-card :title="$t('pages.login.user.card_contact_info.title')" class="market-contact">
    <ul class="market-contact__list">
      <li v-if="market.address">
        <b-icon icon="geo-alt" class="market-contact__icon" />
        <a
          v-if="market.addressUrl"
          :href="market.addressUrl"
          target="_blank"
          rel="noopener"
        >
          {{ market.address }}
        </a>
        <span v-else>{{ market.address }}</span>
      </li>
      <li v-if="market.supportPhone">
        <b-icon icon="telephone" class="market-contact__icon" />
        <a :href="`tel:${market.supportPhone}`">{{ market.supportPhone }}</a>
      </li>
      <li v-if="market.supportEmail">
        <b-icon icon="envelope" class="market-contact__icon" />
        <a :href="`mailto:${market.supportEmail}`">{{ market.supportEmail }}</a>
      </li>
      <li v-if="market.websiteUrl">
        <b-icon icon="globe" class="market-contact__icon" />
        <a
          :href="market.websiteUrl"
          target="_blank"
          rel="noopener"
        >
          {{ market.websiteUrl }}
        </a>
      </li>
      <li v-if="market.onlineBookingFeature && market.showPaymentTerms">
        <b-icon icon="file-text" class="market-contact__icon" />
        <router-link
          :to="{ name: 'market-terms', params: { marketId: market.marketId } }"
          target="_blank"
          rel="noopener"
        >
          {{ $t('pages.login.user.payment_terms') }}
        </router-link>
      </li>
    </ul>
    <b-button
      block
      variant="outline-primary"
      class="mt-3"
      @click="$bvModal.show('feedback-form')"
    >
      {{ $t('pages.feedback_form.button', { company_name: market.visualName }) }}
    </b-button>
    <feedback-modal
      :market="market"
      modalId="feedback-form"
      @formSubmit="formSubmit"
    />
  </market-card>
</template>

<script>
  import FeedbackModal from '@base/components/FeedbackModal.vue'
  import MarketFeedback from '@base/mixins/MarketFeedback.vue'
  import MarketCard from '@base/components/market/MarketCard.vue'

  export default {
    name: 'MarketContactCard',

    components: {
      FeedbackModal,
      MarketCard,
    },

    mixins: [MarketFeedback],

    props: {
      market: {
        type: Object,
        required: true,
      },
      marketFeedback: {
        required: true,
      },
    },
  }
</script>

<style scoped>
  .market-contact__list li {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.375rem 0;
    overflow-wrap: anywhere;
  }

  .market-contact__icon {
    flex: 0 0 auto;
    margin-top: 0.2rem;
    color: var(--ui-muted);
  }
</style>
